import { render, staticRenderFns } from "./NestedCategorySort.vue?vue&type=template&id=8f48176e&scoped=true"
import script from "./NestedCategorySort.vue?vue&type=script&lang=js"
export * from "./NestedCategorySort.vue?vue&type=script&lang=js"
import style0 from "./NestedCategorySort.vue?vue&type=style&index=0&id=8f48176e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f48176e",
  null
  
)

export default component.exports